var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1753 8.65593C23.681 8.15027 23.681 7.33043 23.1753 6.82476C22.6696 6.3191 21.8498 6.3191 21.3441 6.82476L15 13.1689L8.65581 6.82476C8.15015 6.3191 7.33031 6.3191 6.82464 6.82476C6.31898 7.33043 6.31898 8.15027 6.82464 8.65593L13.1688 15.0001L6.82464 21.3442C6.31898 21.8499 6.31898 22.6698 6.82464 23.1754C7.33031 23.6811 8.15015 23.6811 8.65581 23.1754L15 16.8313L21.3441 23.1754C21.8498 23.6811 22.6696 23.6811 23.1753 23.1754C23.681 22.6698 23.681 21.8499 23.1753 21.3442L16.8311 15.0001L23.1753 8.65593Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.acaf581fb8239d21ff91bdef5f394d17.svg";
export { ForwardRef as ReactComponent };